import { Pool } from '../../../../../../apis/pool.api';
import {
  CPSConfigAlarmElement,
  IProduct,
  IProductFunctionnality,
} from '../../../IProduct';
import { IMaster } from '../../../IMaster';
import { P00039DataRxTxIndex } from '../../P00039Sync';

export function P0003607Alarm(
  pool: Pool,
  productClass: IProduct,
  masterClass: IMaster,
  getValue: any,
): CPSConfigAlarmElement[] {
  let res: CPSConfigAlarmElement[] = [];

  if (getValue('esSAlarme') === 1) {
    if (getValue('esSArretElectrolyseurProtectionHivernage') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.ELECTROLYSEUR_STANDARD,
        functionalityTitle: 'P0003607.dashboard.electrolyseur',
        title: 'P0003607.status.protectionHivernage',
      });
    }

    if (getValue('esSArretElectrolyseurProtectionDebit') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.ELECTROLYSEUR_STANDARD,
        functionalityTitle: 'P0003607.dashboard.electrolyseur',
        title: 'P0003607.status.detectionDebit',
      });
    }

    if (getValue('esSSecuriteDesinfection') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.ELECTROLYSEUR_STANDARD,
        functionalityTitle: 'P0003607.dashboard.electrolyseur',
        title: 'P0003607.status.secuDesinfection',
      });
    }

    if (masterClass.hasProduct(pool, productClass) === 2) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.ELECTROLYSEUR_STANDARD,
        functionalityTitle: 'P0003607.dashboard.electrolyseur',
        title: 'P0003607.status.connexionCoffret',
      });
    }
  }

  return res;
}
